import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { AnalyticsHeaderModule, ErrorPageModule, RedirectPageModule, SHybridHttpModule, SHybridHttpService, SLoaderBlockUiModule, SPanelModule, BreadcrumbModule, GoogleAnalyticsModule } from "@senior-gestao-pessoas/angular-components";
import { LocaleModule } from "@seniorsistemas/angular-components";
import { AdvancedFilterModule, TranslationsModule } from '@seniorsistemas/platform-components';
import { HotkeyModule } from "angular2-hotkeys";
import { TabViewModule } from "primeng/tabview";
import { SelectButtonModule } from 'primeng/selectbutton';
import { environment } from "../environments/environment";
import { fallback as analyticsFallbackTs } from "../locale/fallback";
import analyticsFallback from "../locale/pt-BR.json";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PageContainerComponent } from "./core/pages/page-container/page-container.component";
import { HcmConfigService } from "./core/services/hcm-config.service";
import { PermissionResourceService } from "./core/services/permission-resource.service";
import { AppointmentApiService } from "./modules/appointment/utils/appointment-api.service";
import { ReactiveFormsModule } from '@angular/forms';
import {ToastModule} from 'primeng/toast';

export const translations = environment.production ? analyticsFallbackTs : analyticsFallback;

@NgModule({
	declarations: [
		AppComponent,
		PageContainerComponent
	],
	imports: [
		AppRoutingModule,
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		LocaleModule.forRoot(),
		HotkeyModule.forRoot(),
		TranslateModule.forRoot(),
		TranslationsModule.forRoot([
			{
				domain: "hcm",
				service: "analytics",
				fallback: translations
			},
			{
				domain: "hcm",
				service: "analytics_sst",
				fallback: translations
			},
			{
				domain: "hcm",
				service: "analytics_payroll",
				fallback: translations
			}
		]),
		TabViewModule,
		SelectButtonModule,
		AnalyticsHeaderModule,
		SHybridHttpModule,
		SPanelModule,
		ErrorPageModule,
		AdvancedFilterModule,
		RedirectPageModule,
		SLoaderBlockUiModule,
		BreadcrumbModule,
		ToastModule,
		GoogleAnalyticsModule.forRoot({ module: "analytics" })
	],
	providers: [
		HcmConfigService,
		SHybridHttpService,
		PermissionResourceService,
		AppointmentApiService,
		TranslateService
	],
	bootstrap: [AppComponent]
})
export class AppModule {
}
